import { render, staticRenderFns } from "./BaseSideBarListItem.vue?vue&type=template&id=c32f1ea4&scoped=true&"
import script from "./BaseSideBarListItem.vue?vue&type=script&lang=ts&"
export * from "./BaseSideBarListItem.vue?vue&type=script&lang=ts&"
import style0 from "./BaseSideBarListItem.vue?vue&type=style&index=0&id=c32f1ea4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c32f1ea4",
  null
  
)

export default component.exports